function capitalise(str = ''): string {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

function hexToRGB(hex = '', alpha = 1) {
  if (hex.length === 7) {
    const r = parseInt(hex.slice(1, 3), 16),
      g = parseInt(hex.slice(3, 5), 16),
      b = parseInt(hex.slice(5, 7), 16);

    return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + alpha + ')';
  } else return '';
}

export { capitalise, hexToRGB };
